import * as React from 'react';
import TextField, { TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField';
import { FieldProps, getIn } from 'formik';

export interface FormikTextFieldProps
    extends FieldProps,
        Omit<MuiTextFieldProps, 'name' | 'value' | 'error'> {}

export function fieldToTextField({
    disabled,
    field,
    form: { isSubmitting, touched, errors },
    ...props
}: FormikTextFieldProps): MuiTextFieldProps {
    const fieldError = getIn(errors, field.name);
    const showError = getIn(touched, field.name) && !!fieldError;

    return {
        ...props,
        ...field,
        error: showError,
        helperText: showError ? fieldError : props.helperText,
        disabled: disabled ?? isSubmitting,
        variant: props.variant,
    };
}

export default function     FormikInput({ children, ...props }: FormikTextFieldProps) {
    return <TextField {...fieldToTextField(props)}>{children}</TextField>;
}
